import { coastSites } from './coast-sites.js';
import { planEncounters, type EncounterPlan } from './encounter-sites.js';
export type { EncounterPlan } from './encounter-sites.js';
export type { EncounterMember } from './roles.js';

/**
 * Ember Coast uses a fixed four-member, level-1 reference party (Monster Budget 4), regardless of who is connected. Each crew is
 * generated from its site (`coast-sites.ts`) against that party, so crews range from swarms to pairs of elites at the tier the site
 * names. Enemy stat blocks stay unchanged.
 */
/** Balance reference, independent of the playable roster and connected accounts. */
export const COAST_BALANCE_PARTY = { heroes: 4, level: 1 } as const;

export const coastEncounters: EncounterPlan[] = planEncounters(coastSites, { mapId: 'ember-coast', party: COAST_BALANCE_PARTY });
